import { Switch } from "antd";

const paymentTypeColumns = [
  {
    title: "Payment Type Name",
    dataIndex: "name",
    key: "type_name",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
  },
];

export default paymentTypeColumns;
